import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DrawerService {
  private menu = signal<string>("");
  readonly selectedMenu = this.menu.asReadonly();

  setMenu(url: string) {
    this.menu.set(url);
  }
}
